var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close_Button",
    "data-name": "Close Button",
    transform: "translate(-1071 -40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1071 40)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "cross_line_2",
    "data-name": "cross line 2",
    y2: 12,
    transform: "translate(1091.27 51.785) rotate(45)",
    fill: "none",
    stroke: "#2b3382",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "cross_line_1",
    "data-name": "cross line 1",
    y2: 12,
    transform: "translate(1091.27 60.27) rotate(135)",
    fill: "none",
    stroke: "#2b3382",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuClose);
export default __webpack_public_path__ + "static/media/mobile-menu-close.ccc63dd21b1c1acff3c2da2839baeb7c.svg";
export { ForwardRef as ReactComponent };